<!--文化纪首页 大课间展演 20211123-->
<template>
  <div class="gray-back" style="height: 100%">
        <div v-if="user.id> 1" style="margin:10px ; color:#fff;background:#000;padding:10px;border-radius:10px" @click="logout()">{{user.name}}[切换账号]</div>
    <div class="box">
 

        <div style="position:relative;">
          <div style="padding: 10px;"><img style="width: 100%; " :src="row.pic_url"/></div>
          <div class="savebtn" style="text-align: center ;     position: absolute;
    bottom: 40px;
    left: 0;
    right: 0;"> 
            <!-- <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round v-rblink="{name:'DakejianApply',query:{}}">我要报名
            </van-button> -->
             <!-- <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round v-rblink="{name:'DakejianApplyList',query:{}}">报名记录
            </van-button> -->


          </div>
        </div>

        <div class="savebtn" style="text-align: center;margin-bottom:10px">

            <van-button
             v-if="user.id> 1"
                style="width: 3rem"
                size="normal" round  v-rblink="{name:'ISaiApplyListDianxin',query:{}}">上传记录
            </van-button>
            <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round @click="go()">开始上传
            </van-button>

        </div>


        <div class="savebtn" style="text-align: center"> 
            <!-- <van-button 
                style="width: 3rem"
                size="normal" round  @click="goShow()">展示专区
            </van-button>
            <van-button 
                style="width: 3rem"
                size="normal" round @click="goVote()">投票专区
            </van-button> -->
            <!-- <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round v-rblink="{name:'DakejianApply',query:{}}">我要报名
            </van-button> -->
             <!-- <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round v-rblink="{name:'DakejianApplyList',query:{}}">报名记录
            </van-button> -->


          </div>

    </div>
  </div>
</template>
<style scoped>

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
  margin: 0.2rem auto;
}

.news-title {
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
}

.news-read-time {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-top: 0.2rem;
}

.news-content {
  font-size: 14px;
  text-align: center;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 20px;
  color: rgba(34, 34, 34, 1);
  line-height: 28px;
}

.news-content >>> img {
  max-width: 100% !important;
}

.news-content >>> iframe {
  width: 100% !important;
}

.row1 {
  /*padding: 10px;*/
  margin: 0 10px;
}

.row4 {
  display: flex;
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  height: 65px;
  /*flex-wrap: wrap;*/
}

.row4 img {
  /*width: calc(25% - 10px);*/
  flex: 1;
  width: 25%;
  /*margin: 0 10px 10px 0;*/
}

.row4 img + img {

  margin-left: 10px;

}


.no_club {
  height: 4.72rem;
  background-image: url("../../../assets/images/bg-weijiarujulebu@2x.png");
  background-size: 100% 100%;
}
.create_btn {
  width: 86px;
  height: 32px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
}

</style>

<script>
import Vue from "vue";
import {Tab, Tabs, List, PullRefresh, Toast} from "vant";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import LoginDialog from '@/components/LoginDialog.vue';

Vue.use(Tab)
    .use(Tabs)
    .use(PullRefresh)
    .use(List)
    .use(Toast);

export default {
  name: "Wenhuaji",
  components: {
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
    LoginDialog
  },

  data: function () {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [],
      catelist: [],
      list: [],
      row: {},
      params: {
        cate_id: 64,
        pageNo: 1,
        pageSize: 10
      },
      row: {
        pic_url:'',
      },
      user:{

      }
    };
  },
  filters: {},
  mounted() {
    document.title = "2025年“天翼杯”员工运动健康活动";
    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;
    let that = this;
 

    this.fetch();
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.post('/api/cms/dianxinDetail', { 
      }, (res) => { 
        that.row = res.data.row
        that.user = res.data.user
      }, (res) => {
        // Toast.fail(res.msg);
      })
 
    },

    toast(msg){
      Toast(msg);
    },

    go(type) {
      // rbLink({name:'H5',query:{ url : this.dakejian.jump_url } });
      let that = this; 
      if(this.user.id>1){
        // rbLink({name:'ISaiApplyFormStep1Dianxin',query:{saiqu_id:751}});
        rbLink({name:'ISaiApplyFormStep1Dianxin',query:{saiqu_id:767}});
      }else{
        rbLink({name:'loginDianxin',query:{}});
      }
    },
    goShow(){
       Toast('即将开放');
    },
    goVote(){
       Toast('即将开放');
    },

    logout(){ 
      let that = this;
      localStorage.removeItem('_token');
      localStorage.removeItem('_pspt');
      this.$api.get('/api/index/logout',{},r=>{ 
      rbLink({name:'loginDianxin',query:{}});
      });


    },

    gowenjuan() {
      // rbLink({name:'H5',query:{ url : this.dakejian.jump_url } });
      let that = this;
      appEvent({
        name: 'downloadFile',
        query: {
          name: 'xxx',
          url: 'https://qywx.wjx.cn/vm/QMVGNRB.aspx',
        }
      });
    },
    go2(type) {
      rbLink({name: 'Page331', query: {}});
    },

    go3(type) {
      rbLink({name: 'CRuralList', query: {}});
    },
    goDabiao(){
      let that = this;
      appEvent({
        name: 'downloadFile',
        query: {
          name: 'xxx',
          url: that.dakejian.dabiao_url,
        }
      });
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// Dianxin.vue?87c3ac40